/**
 * Checks if an HTMLElement is or is contained within an interactive element.
 *
 * Interactive elements include:
 * - <button> elements
 * - <a> elements
 * - <input> elements
 * - Elements with role="link"
 * - Elements with role="button"
 * - Elements with role="menuitem"
 * - Elements with role="menuitemcheckbox"
 * - Elements with role="menuitemradio"
 *
 * This uses `closest()` to check ancestors, so it correctly handles cases where
 * the target is a child element (e.g., a span inside a button).
 *
 * @param target - The HTMLElement to check (typically from event.target)
 * @returns true if the target is or is contained within an interactive element
 */
export function isInteractiveElement(target) {
    return !!(target.closest('button') ||
        target.closest('a') ||
        target.closest('input') ||
        target.closest('[role="link"]') ||
        target.closest('[role="button"]') ||
        target.closest('[role="menuitem"]') ||
        target.closest('[role="menuitemcheckbox"]') ||
        target.closest('[role="menuitemradio"]'));
}
//# sourceMappingURL=isInteractiveElement.js.map